/**
 * Created by Sasha on 7/25/2018.
 */
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class BlogTypeService  {
  blogTypes: any[];
  onBlogTypeChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getBlogTypes()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getBlogTypes () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/blogType/blogTypes'  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.blogTypes = response;
          this.onBlogTypeChanged.next(this.blogTypes);
          resolve(response);
        }, reject);
    });

  }

  getBlogTypeById(id) {
    return this.http.get(this.api.baseUrl + '/blogType/blogType?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteBlogType(id) {
    return this.http.delete(this.api.baseUrl + '/blogType/deleteBlogType?id=' + id , this.api.jsonTokenHeaders);
  }

  addBlogType(data) {
    return this.http.post(this.api.baseUrl + '/blogType/addBlogType' , data , this.api.formDataHeaders);
  }

  getBlogTypeDropDown() {
    return this.http.get(this.api.baseUrl + '/blogType/blogTypes'  , this.api.jsonTokenHeaders);
  }
}
